import { routePrefix } from '@/utils/routes/routes';
import React from 'react';
import { Link } from 'react-router';

const TrustSection = ({ themeData }: any) => {
  return (
    <>
      <section className="trust-section">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="trust-content">
                <h2
                  className="section-title"
                  style={{
                    color: `#${themeData?.theme_1?.home?.section_3?.h2color}`,
                  }}
                >
                  {themeData?.theme_1?.home?.section_3?.title}
                </h2>
                <p
                  style={{
                    color: `#${themeData?.theme_1?.home?.section_3?.paracolor}`,
                  }}
                >
                  {themeData?.theme_1?.home?.section_3?.paragraph}
                </p>
                <h4
                  style={{
                    color: `#${themeData?.theme_1?.home?.section_3?.h3color}`,
                  }}
                >
                  {themeData?.theme_1?.home?.section_3?.sub_heading}
                </h4>
                <ul>
                  {themeData?.theme_1?.home?.section_3?.check_list &&
                    Object.keys(
                      themeData?.theme_1.home.section_3.check_list
                    ).map((key: any) => (
                      <li
                        key={key}
                        style={{
                          color: `#${themeData?.theme_1?.home?.section_3?.paracolor}`,
                        }}
                      >
                        {themeData?.theme_1.home.section_3.check_list[key].list}
                      </li>
                    ))}
                </ul>

                <div className="trust-content-btn">
                  <Link
                    to={`${routePrefix}/about`}
                    className="btn primary-btn hover-btn"
                    style={{
                      background: `#${themeData?.theme_1?.home?.section_3?.btn_group?.btn1?.bg_color}`,
                      color: `#${themeData?.theme_1?.home?.section_3?.btn_group?.btn1?.color}`,
                    }}
                  >
                    {themeData?.theme_1?.home?.section_3?.btn_group?.btn1?.text}
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="trust-content-img">
                <img src={themeData?.theme_1?.home?.section_3?.banner} alt="" />
              </div>
            </div>
          </div>
          {/* {settingsData?.WebsiteSettings?.site_title_en.includes('Sasian') && (
            <div className="sascallbtn pt-5 text-center">
              <a href="tel:+(44)7749300244" className="btn primary-btn">
                Call Us
              </a>
            </div>
          )} */}
        </div>
      </section>
    </>
  );
};

export default TrustSection;
